import React, { memo } from 'react';
import PropTypes from 'prop-types';

function EconomyTruckItem({ testid, content, className, title }) {
  return (
    <div className={className}>
      <p>{title}</p>
      <div className="icon-text">
        <div className="icon-img"></div>
        <p data-testid={`${testid}-content-value`}>{content}</p>
      </div>
    </div>
  );
}

EconomyTruckItem.propTypes = {
  testid: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default memo(EconomyTruckItem);